export type FeatureFlag = 'field_posts' | 'telemedicine'
export type FeatureFlags = Record<FeatureFlag, boolean>

export const FEATURES_OFF: FeatureFlags = { field_posts: false, telemedicine: false }

interface FeatureSurface {
    pages: string[]
    apis: string[]
    roles: string[]
}

const FEATURE_SURFACES: Record<FeatureFlag, FeatureSurface> = {
    field_posts: { pages: ['/field-posts', '/settings/field-posts'], apis: ['/api/field-posts'], roles: ['field_medic'] },
    telemedicine: { pages: ['/telemedicine'], apis: ['/api/telemedicine'], roles: ['telemedicine_admin', 'telemedicine_doctor'] },
}

function isUnder(path: string, prefix: string): boolean {
    return path === prefix || path.startsWith(prefix + '/')
}

function disabledFeatureFor(path: string, flags: FeatureFlags, surface: 'pages' | 'apis'): FeatureFlag | undefined {
    return (Object.keys(FEATURE_SURFACES) as FeatureFlag[])
        .find(flag => !flags[flag] && FEATURE_SURFACES[flag][surface].some(prefix => isUnder(path, prefix)))
}

// Unknown or unreadable flags stay off, so a missing table or a failed read hides every feature.
export function toFeatureFlags(rows: { key: string; enabled: boolean }[] | null | undefined): FeatureFlags {
    const flags = { ...FEATURES_OFF }
    for (const row of rows ?? []) {
        if (row.key in flags) flags[row.key as FeatureFlag] = row.enabled === true
    }
    return flags
}

export function disabledFeatureForPage(path: string, flags: FeatureFlags): FeatureFlag | undefined {
    return disabledFeatureFor(path, flags, 'pages')
}

export function disabledFeatureForApi(path: string, flags: FeatureFlags): FeatureFlag | undefined {
    return disabledFeatureFor(path, flags, 'apis')
}

export function isRoleDisabled(role: string | undefined, flags: FeatureFlags): boolean {
    if (!role) return false
    return (Object.keys(FEATURE_SURFACES) as FeatureFlag[])
        .some(flag => !flags[flag] && FEATURE_SURFACES[flag].roles.includes(role))
}

export function isFeatureApiPath(path: string): boolean {
    return disabledFeatureForApi(path, FEATURES_OFF) !== undefined
}

export function isFeatureRole(role: string | undefined): boolean {
    return isRoleDisabled(role, FEATURES_OFF)
}
